/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/comps/h5/Search/components/SearchConditionDrawer.tsx
 * @Description:
 */
/* eslint-disable react-hooks/exhaustive-deps */
import { materialsSearch } from 'api/mall';
import CategoriesDrawer from 'comps/CategoriesDrawer';
import SearchFooter from 'comps/SearchFooter';
import { LocContext, SiteContext, UserContext } from 'libs/contexts';
import { useRouter } from 'next/router';
import { chain, filter, groupBy, head, map, mapIndexed, pipe, transpose } from 'rambdax';
import { useContext, useEffect, useRef, useState } from 'react';
import { Popup } from 'react-vant';
import { cls } from 'reactutils';
import { IAgreement, ConditionItem, FilterItem } from './types/search';
import { CurrentUserTypeSource, UserSource } from 'libs/enums';
import { useNetActionPriceContext } from 'libs/contexts';
import AgreementSelect from './AgreementSelect';
import ContractSelect from './ContractSelect';
const PopupStyle = {
  width: 320,
  height: '100%',
};

export const GoodsFn = (activeIndex: any[]): ConditionItem => ({
  name: '商品分类',
  type: 'radio',
  local: true,
  values: [
    {
      name: '零星物资',
      sysNo: 1,
      active: activeIndex.includes(1),
      parentName: '商品分类',
    },
    {
      name: '办公用品',
      sysNo: 2,
      active: activeIndex.includes(2),
      parentName: '商品分类',
    },
  ],
});

export default function SearchCondtionDrawer({
  visible,
  onClose,
  conditionList: initConditionList,
  onChange = () => {},
  keyword,
  conditionTypeList: initConditionTypeList,
  value,
  shopSysNo,
  selectAreas,
}: any) {
  const [morePopupVisible, setMorePopupVisible] = useState(false);
  const [moreItemIndex, setMoreItemIndex] = useState(0);
  const [triggerOnChange, setTriggerOnChange] = useState(false);
  const [resetState, setResetState] = useState(false);

  const router = useRouter();
  const resetRef = useRef(false);
  const userInfo = useContext(UserContext);
  const site = useContext(SiteContext);
  const {
    loading,
    buildConditionParams,
    setFlattenState,
    flattenState,
    renderState,
    conditionTypeList,
    tradeRuleState,
    setTradeRuleState,
  } = useConditionList(
    initConditionList,
    onChange,
    initConditionTypeList,
    router.query.catId as string,
    keyword,
    shopSysNo,
  );
  const handleMoreClick = (index: number) => {
    setMoreItemIndex(index);
    setMorePopupVisible(true);
  };

  const updateState = (item: any, sync = true) => {
    setFlattenState((prev) =>
      prev.map((v) => (v.sysNo === item.sysNo ? { ...v, active: !v.active } : { ...v })),
    );
    sync && setTriggerOnChange(true);
  };

  const updateTradeRule = (item) => {
    item.active = !item.active;
    setTradeRuleState({ ...tradeRuleState });
    setTriggerOnChange(true);
  };

  const handleResetAll = () => {
    setTriggerOnChange(true);
    resetRef.current = true;
    setFlattenState((p) =>
      p.map((v) => {
        return { ...v, active: false };
      }),
    );
    setTradeRuleState({
      ...tradeRuleState,
      values: tradeRuleState.values?.map((item) => ({
        ...item,
        active: false,
      })),
    });
  };

  useEffect(() => {
    if (resetState) {
      onChange(
        {
          ...value,
          // keywordType: searchType(),
          catId: router.query.catId,
          categorySysNoList: [],
          upstreamSupplierSysNoList: [],
        },
        renderState,
      );
      setResetState(false);
    }
  }, [resetState]);

  const handleConfirm = () => onClose();
  const handleDrawerClose = () => onClose();
  const handleMorePopupConfirm = () => setMorePopupVisible(false);
  const handleMorePopupOnClose = () => setMorePopupVisible(false);

  const handleMorePopupReset = () => {
    setTriggerOnChange(true);
    setFlattenState((prev) =>
      prev.map((v: any) => {
        if (renderState[moreItemIndex].name === v.parentName) {
          return { ...v, active: false };
        } else {
          return v;
        }
      }),
    );
  };

  useEffect(() => {
    if (triggerOnChange) {
      const newParams = {
        ...buildConditionParams(flattenState),
        catId: router.query.catId,
        categorySysNoList: [],
        upstreamSupplierSysNoList: [],
        contractAgreementSysNoList: [],
      };
      onChange(resetRef.current ? newParams : buildConditionParams(flattenState), renderState);
      resetRef.current = false;
      setTriggerOnChange(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerOnChange]);

  const changeType = (val, prop) => {
    const catId = val[prop].join(',');
    onChange(
      {
        ...val,
        catId,
      },
      renderState,
    );
  };

  const isInSidePurchase =
    userInfo?.currentUserType === CurrentUserTypeSource.purchaser &&
    userInfo?.organizationSource === UserSource.inside; //是否为内部采购商
  return (
    <>
      <Popup
        visible={visible}
        onClose={handleDrawerClose}
        position="right"
        style={PopupStyle}
        overlayClass="condition-drawer-popup"
        transition="simple-right-transition"
      >
        <div className={cls('container')}>
          <div className={cls('conditionContainer')}>
            {userInfo && site?.mall?.enableSelectAllSkuOfBindAgreement === 0 && (
              <div className="trade-rule-block-wrap">
                <ConditionBlock item={tradeRuleState} updateState={updateTradeRule} />
              </div>
            )}
            {isInSidePurchase && (
              <>
                <div className="blockContainer">
                  <div className="blockTitle">交易规则</div>
                  <div id="agreement-container" style={{ position: 'relative' }}>
                    <AgreementSelect
                      selectAreas={selectAreas}
                      getPopupContainer={() => document.getElementById('agreement-container')}
                      value={value.agreementSysNoList}
                      onChange={(agreementSysNo) => {
                        onChange(
                          {
                            agreementSysNoList: [agreementSysNo],
                          },
                          renderState,
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="blockContainer">
                  <div className="blockTitle">合同</div>
                  <div id="contract-container" style={{ position: 'relative' }}>
                    <ContractSelect
                      selectAreas={selectAreas}
                      getPopupContainer={() => document.getElementById('contract-container')}
                      value={value.contractAgreementSysNoList}
                      onChange={(contractSysNo) => {
                        onChange(
                          {
                            contractAgreementSysNoList: [contractSysNo],
                          },
                          renderState,
                        );
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            <CategoriesDrawer
              conditionList={conditionTypeList}
              onChange={changeType}
              value={value}
            />
            {renderState.map((v: any, index: number) => (
              <ConditionBlock
                item={v}
                key={index}
                onMoreClick={() => handleMoreClick(index)}
                updateState={updateState}
                loading={loading}
              />
            ))}
          </div>
          <SearchFooter onReset={() => handleResetAll()} onConfirm={handleConfirm} />
        </div>
        <MorePopup
          item={renderState[moreItemIndex]}
          visible={morePopupVisible}
          setMorePopupVisible={setMorePopupVisible}
          updateState={updateState}
          handleMorePopupConfirm={handleMorePopupConfirm}
          handleMorePopupReset={handleMorePopupReset}
          onClose={handleMorePopupOnClose}
        />
      </Popup>
      <style jsx>{`
        .container,
        .moreContainer {
          display: flex;
          height: 100vh;
          flex-direction: column;
        }

        .conditionContainer,
        .moreContentContainer {
          flex: 1 1 auto;
          overflow-y: auto;
        }

        :global .more-popup {
          background: none;
        }

        :global .condition-drawer-popup {
          background: rgba(0, 0, 0, 0.6);
        }

        .blockContainer {
          padding-top: 20px;
          padding-bottom: 30px;
          border-bottom: 2px solid #f9f9f9;
          padding: 0 20px;
          padding-top: 20px;
        }
        .blockTitle {
          font-size: 16px;
          color: #2e2d37;
          text-align: center;
          font-weight: 600;
          margin-bottom: 16px;
          text-align: left;
        }
        .no-agreement-tip{
          margin-left: 15px;
          color: red;
        }

        .trade-rule-block-wrap :global(.item) {
          width: 160px;
        }
      `}</style>
    </>
  );
}

function ConditionBlock({ item, onMoreClick, hideMore = true, updateState, loading }: any) {
  if (!item?.values || (loading && !item.local)) return <div />;
  const hasMore = item.values.length > 8;
  const values = !hideMore ? item.values : item.values.slice(0, 8);
  const moreActive = item.values.slice(8).some((v: any) => v.active);
  const handleItemClick = (valueItem: any) => {
    if (item.local) {
      updateState(valueItem, false);
    } else {
      updateState(valueItem);
    }
  };
  return (
    <>
      <div className={cls('blockContainer')}>
        <div className={cls('blockTitle')}>{item.name}</div>
        <div className={cls('blockContent')}>
          {values.map((v: any, index: any) => {
            return (
              <div
                key={index}
                className={cls('item', v.active && 'active')}
                onClick={() => handleItemClick(v)}
              >
                <div className={'ellip'}>{v.name}</div>
              </div>
            );
          })}
          {hideMore && hasMore && (
            <div className={cls('item', moreActive && 'active')} onClick={() => onMoreClick(item)}>
              更多
            </div>
          )}
        </div>
      </div>
      <style jsx>{`
        .blockContent {
          flex-wrap: wrap;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .blockTitle {
          font-size: 16px;
          color: #2e2d37;
          text-align: center;
          font-weight: 600;
          margin-bottom: 16px;
          text-align: left;
        }

        .blockContainer {
          padding-top: 20px;
          padding-bottom: 30px;
          border-bottom: 2px solid #f9f9f9;
          padding: 0 20px;
          padding-top: 20px;
        }

        .blockContainer:last-child {
          border-bottom: none;
        }
        .ellip {
          padding: 0 4px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .item {
          width: 84px;
          height: 30px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          background: #f5f5f5;
          border-radius: 16px;
          margin-bottom: 14px;
          margin-right: 12px;
        }

        .item:nth-of-type(3n) {
          margin-right: 0;
        }

        .item.active {
          color: var(--primaryColor);
          background: #edf3ff;
          border: 0 solid var(--primaryColor);
        }
      `}</style>
    </>
  );
}

function MorePopup({
  visible,
  onClose,
  item,
  updateState,
  handleMorePopupConfirm,
  handleMorePopupReset,
}: any) {
  return (
    <Popup
      visible={visible}
      onClose={onClose}
      position="right"
      style={PopupStyle}
      overlayClass="more-popup"
      transition="simple-right-transition"
    >
      <div className={'moreContainer'} style={{ paddingTop: 0 }}>
        <div className={cls('conditionContainer')}>
          <ConditionBlock item={item} hideMore={false} updateState={updateState} />
        </div>
        <SearchFooter
          onReset={() => {
            handleMorePopupReset();
          }}
          onConfirm={handleMorePopupConfirm}
        />
      </div>
      <style jsx>{`
        .container,
        .moreContainer {
          display: flex;
          height: 100vh;
          flex-direction: column;
        }
        .conditionContainer,
        .moreContentContainer {
          flex: 1 1 auto;
          overflow-y: auto;
        }
      `}</style>
    </Popup>
  );
}

export function useConditionList(
  initCondition: any,
  onChange: any,
  initConditionTypeList: { categoryList: any[]; hotCategoryList: any[] },
  catId?: string,
  keyword?: string,
  shopSysNo?: string,
) {
  const [flattenState, setFlattenState] = useState<FilterItem[]>(() =>
    produceFlattenValues(initCondition),
  );

  const [conditionTypeList, setConditionTypelist] = useState([]);
  const renderState = getRenderState(flattenState);
  const getNetPriceList = useNetActionPriceContext();
  const { location } = useContext(LocContext);
  const fetchOnFirstTime = useRef(false);
  const [loading, setLoading] = useState(false);
  const enableCache = false;
  const mounted = useRef(false);
  const [syncStateWithParent, setSyncStateWithParent] = useState(false);
  const [selectedContractOrAgre, setSelectedContractOrAgre] = useState({} as IAgreement);
  const [tradeRuleState, setTradeRuleState] = useState({
    name: '交易规则',
    values: [
      {
        name: '已绑定交易规则的商品',
        active: false,
      },
    ],
  });
  const router = useRouter();

  useEffect(() => {
    if (fetchOnFirstTime.current) {
      fetchData();
    } else {
      fetchOnFirstTime.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.areaCode, router.query.key]);

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    if (syncStateWithParent) {
      onChange(buildConditionParams(flattenState), renderState);
    }
    setSyncStateWithParent(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncStateWithParent]);

  function buildConditionParams(flattenState: any) {
    const [attributeNameList, attributeValueList] = pipe(
      filter(
        (v: any) =>
          v.parentName !== '商品分类' && v.parentName !== '品牌' && v.parentName !== '配送商',
      ),
      filter((v: any) => v.active),
      map((v) => [v.parentName, v.name]),
      transpose,
    )(flattenState);
    const wrapContractAgreement = () => {
      const sysNo = selectedContractOrAgre?.sysNo;
      const params = {
        agreementSysNoList: [], // 按交易规则查询时 交易规则编号
      };
      if (!sysNo) return params;
      params.agreementSysNoList = [sysNo];
      return params;
    };
    return {
      brandSysNoList: pipe(
        filter((v: any) => v.parentName === '品牌'),
        filter((v: any) => v.active),
        map((v: any) => v.sysNo),
      )(flattenState),
      upstreamSupplierSysNoList: pipe(
        filter((v: any) => v.parentName === '配送商'),
        filter((v: any) => v.active),
        map((v: any) => v.sysNo),
      )(flattenState),
      attributeNameList,
      attributeValueList,
      ...wrapContractAgreement(),
      onlyShowAgreement: !!tradeRuleState.values?.find((item) => item.active),
    };
  }

  async function fetchData() {
    try {
      setLoading(true);
      const res = await materialsSearch({
        pageNo: 1,
        pageSize: 30,
        pageStart: 0,
        queryTotal: true,
        levelCode: location.areaCode,
        catId,
        key: router.query.key,
        shopSysNo: shopSysNo || router.query.shopSysNo,
      });
      const brandList = res?.data?.brandList || [];
      const spuList = res?.data?.spuAttributeList || [];
      const brands = produceFlattenValues([{ name: '品牌', values: brandList }], 1);
      const spus = produceFlattenValues(spuList, 2);
      setFlattenState(() => {
        const newState = [...brands, ...spus].filter(Boolean).map((v: any) => ({
          ...v,
          active: false,
        }));
        return newState;
      });
      setSyncStateWithParent(true);
      setConditionTypelist([
        {
          type: 'checkbox',
          title: '分类',
          labelKey: 'name',
          prop: 'categorySysNoList',
          hasMoreBtn: true,
          show: true,
          hotSubList: res?.data?.hotCategoryList,
          totalSubList: res?.data?.categoryList,
        },
      ]);
      getNetPriceList &&
        getNetPriceList(spuList?.datas, (list) => {
          const spuss = produceFlattenValues({ ...(spuList || {}), datas: list }, 2);
          setFlattenState(() => {
            const newState = [...brands, ...spuss].filter(Boolean).map((v: any) => ({
              ...v,
              active: false,
            }));
            return newState;
          });
        });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (initConditionTypeList?.hotCategoryList) {
      setConditionTypelist([
        {
          type: 'checkbox',
          title: '分类',
          labelKey: 'name',
          prop: 'categorySysNoList',
          hasMoreBtn: true,
          show: true,
          hotSubList: initConditionTypeList?.hotCategoryList,
          totalSubList: initConditionTypeList?.categoryList,
        },
      ]);
    }
  }, [initConditionTypeList]);

  return {
    loading,
    renderState,
    buildConditionParams,
    enableCache,
    setFlattenState,
    flattenState,
    conditionTypeList,
    tradeRuleState,
    setTradeRuleState,
    selectedContractOrAgre,
    setSelectedContractOrAgre,
  };
}

function produceFlattenValues(init: ConditionItem[], fromIndex = 0): FilterItem[] {
  return pipe(
    mapIndexed((v: ConditionItem, index) => ({
      ...v,
      index: index + fromIndex,
    })),
    chain(augmentValues),
  )(init);
}

function augmentValues(vObj: ConditionItem & { index: number }) {
  return vObj.values.map((v) => ({
    ...v,
    parentName: vObj.name,
    index: vObj.index,
    local: vObj.local,
  }));
}

function getRenderState(flattenState: any) {
  return map(
    ([k, v]) => ({
      name: k,
      values: v,
      local: head(v).local,
    }),
    Object.entries(groupBy((v: any) => v.parentName, flattenState)),
  );
}
